import { InventoryApi, InventoryBoundary, MpxResponseBaseSingle } from '@cibo/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { INVENTORIES_QUERY_KEYS } from './queryKeys'

export const useUploadBoundaryFile = ({
  onSuccess,
  onError,
}: {
  onSuccess: (arg: InventoryBoundary) => void
  onError: (error: AxiosError) => void
}) => {
  const queryClient = useQueryClient()

  return useMutation<
    AxiosResponse<MpxResponseBaseSingle<InventoryBoundary>>,
    AxiosError,
    { inventoryId: string; formData: FormData }
  >(
    ({ inventoryId, formData }) => {
      return InventoryApi.uploadBoundary(inventoryId, formData)
    },
    {
      onSuccess: (response: AxiosResponse<MpxResponseBaseSingle<InventoryBoundary>>) => {
        queryClient.invalidateQueries([
          INVENTORIES_QUERY_KEYS.INVENTORIES,
          response.data.item.inventoryId,
        ])
        onSuccess(response.data.item)
      },
      onError: error => {
        onError(error)
      },
    }
  )
}
